import { Alert, Button, Card, Form, Input, message, Typography } from "antd";
import {
  CloudUploadOutlined,
  LockOutlined,
  MailOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import { useState } from "react";
import { register, sendOtp } from "../services/authService";

const { Text, Title } = Typography;

function OtpInput({ value, onChange, sending, onSend }) {
  return <Input.Group compact className="auth-otp-group">
    <Input value={value} onChange={onChange} size="large" placeholder="Nhập mã OTP" maxLength={6} inputMode="numeric" autoComplete="one-time-code" />
    <Button htmlType="button" size="large" loading={sending} onClick={onSend}>Gửi OTP</Button>
  </Input.Group>;
}

export default function SignUp() {
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const [form] = Form.useForm();
  const history = useHistory();

  const sendOtpCode = async () => {
    setError("");
    try {
      const { email } = await form.validateFields(["email"]);
      setSending(true);
      await sendOtp(email);
      message.success("Đã gửi OTP tới email");
    } catch (requestError) {
      if (requestError.message) setError(requestError.message);
    } finally {
      setSending(false);
    }
  };

  const submit = async (values) => {
    setLoading(true);
    setError("");
    try {
      await register(values);
      message.success("Đăng ký thành công");
      history.push("/sign-in");
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  };

  return <div className="auth-page auth-login-page auth-signup-page">
    <div className="auth-pattern auth-pattern-dots" />
    <div className="auth-pattern auth-pattern-stripes" />
    <Card className="auth-card auth-login-card auth-signup-card" bordered={false}>
      <div className="auth-login-logo"><CloudUploadOutlined /></div>
      <div className="auth-brand auth-login-brand">AUTO UPLOAD</div>
      <Title level={1}>Tạo tài khoản</Title>
      <Text className="auth-login-subtitle">Tạo tài khoản Auto Upload để bắt đầu.</Text>
      {error && <Alert className="auth-alert" type="error" showIcon message={error} />}
      <Form form={form} layout="vertical" onFinish={submit}>
        <Form.Item label="TÊN ĐĂNG NHẬP" name="username" rules={[{ required: true, message: "Nhập tên đăng nhập" }]}>
          <Input size="large" prefix={<UserOutlined />} placeholder="Nhập tên đăng nhập" autoComplete="username" />
        </Form.Item>
        <Form.Item label="EMAIL" name="email" rules={[{ required: true, message: "Nhập email" }, { type: "email", message: "Email không hợp lệ" }]}>
          <Input size="large" prefix={<MailOutlined />} placeholder="Nhập email của bạn" autoComplete="email" />
        </Form.Item>
        <Form.Item label="MÃ OTP" name="otp" rules={[{ required: true, message: "Nhập mã OTP" }]}>
          <OtpInput sending={sending} onSend={sendOtpCode} />
        </Form.Item>
        <Form.Item label="MẬT KHẨU" name="password" rules={[{ required: true, message: "Nhập mật khẩu" }, { min: 6, message: "Mật khẩu cần ít nhất 6 ký tự" }]}>
          <Input.Password size="large" prefix={<LockOutlined />} placeholder="Nhập mật khẩu" autoComplete="new-password" />
        </Form.Item>
        <Button className="auth-login-submit" block size="large" type="primary" htmlType="submit" loading={loading}>Đăng ký</Button>
      </Form>
      <div className="auth-divider"><span>HOẶC</span></div>
      <div className="auth-register-copy"><Text>Đã có tài khoản?</Text> <Link to="/sign-in">Đăng nhập</Link></div>
    </Card>
  </div>;
}
